// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ChangeSignature_container__9jeJb {
  width: 550px;
  height: 85vh;

  display: flex;
  flex-direction: column;
  align-items: flex-start;

  position: absolute;
  top: 92px;
  right: 10px;

  padding: 0px 20px;

  box-shadow: 0px 3px 6px var(--color-theme-gray);
  border: 1px solid var(--color-theme-cloud);

  box-sizing: border-box;
  overflow-y: scroll;
}

.ChangeSignature_signatre_body__eMKjV {
  height: 90%;
  min-height: 470px;
  overflow-y: scroll;
}

.ChangeSignature_button_container__2VvLv {
  justify-content: space-between;
  width: 100%;
  display: flex;
  margin-top: 15px;
}

.ChangeSignature_btn_cancel__kEvJ5 {
  font-weight: bold !important;
  border: 1px solid var(--color-theme-silver) !important;
  color: var(--color-theme-silver);
}

.ChangeSignature_btn_confirm__7lRuw {
  font-weight: bold !important;
  color: var(--color-theme-blue) !important;
  border: 1px solid var(--color-theme-blue) !important;
}

.ChangeSignature_changeNameHeader__FKD1p {
  font-size: 22px;
  color: var(--color-font-2);
  font-weight: bold;
  margin-bottom: 5px;
  text-transform: uppercase;
}

.ChangeSignature_describtion__umteQ {
  text-align: left;
}

.ChangeSignature_email__IF0o4 {
  font-size: 16px !important;
  color: var(--color-font-2);
}

.ChangeSignature_succsse_message__BP7YM {
  width: 100%;
  height: 55px;

  display: flex;
  align-items: center;
  justify-content: space-evenly;

  position: absolute;
  bottom: 0px;
  right: 0px;

  color: var(--color-theme-white);
  font-size: 16px;
  background: var(--color-theme-green);
}

.ChangeSignature_error_message__6f4LE {
  width: 100%;
  height: 55px;

  display: flex;
  align-items: center;
  justify-content: space-evenly;

  position: absolute;
  bottom: 0px;
  right: 0px;

  color: var(--color-theme-white);
  font-size: 16px;
  background: var(--color-theme-red);
}
`, "",{"version":3,"sources":["webpack://./src/@_components/ChangeSignature/ChangeSignature.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,YAAY;;EAEZ,aAAa;EACb,sBAAsB;EACtB,uBAAuB;;EAEvB,kBAAkB;EAClB,SAAS;EACT,WAAW;;EAEX,iBAAiB;;EAEjB,+CAA+C;EAC/C,0CAA0C;;EAE1C,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,WAAW;EACX,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,sDAAsD;EACtD,gCAAgC;AAClC;;AAEA;EACE,4BAA4B;EAC5B,yCAAyC;EACzC,oDAAoD;AACtD;;AAEA;EACE,eAAe;EACf,0BAA0B;EAC1B,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;;EAEZ,aAAa;EACb,mBAAmB;EACnB,6BAA6B;;EAE7B,kBAAkB;EAClB,WAAW;EACX,UAAU;;EAEV,+BAA+B;EAC/B,eAAe;EACf,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,YAAY;;EAEZ,aAAa;EACb,mBAAmB;EACnB,6BAA6B;;EAE7B,kBAAkB;EAClB,WAAW;EACX,UAAU;;EAEV,+BAA+B;EAC/B,eAAe;EACf,kCAAkC;AACpC","sourcesContent":[".container {\n  width: 550px;\n  height: 85vh;\n\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n\n  position: absolute;\n  top: 92px;\n  right: 10px;\n\n  padding: 0px 20px;\n\n  box-shadow: 0px 3px 6px var(--color-theme-gray);\n  border: 1px solid var(--color-theme-cloud);\n\n  box-sizing: border-box;\n  overflow-y: scroll;\n}\n\n.signatre_body {\n  height: 90%;\n  min-height: 470px;\n  overflow-y: scroll;\n}\n\n.button_container {\n  justify-content: space-between;\n  width: 100%;\n  display: flex;\n  margin-top: 15px;\n}\n\n.btn_cancel {\n  font-weight: bold !important;\n  border: 1px solid var(--color-theme-silver) !important;\n  color: var(--color-theme-silver);\n}\n\n.btn_confirm {\n  font-weight: bold !important;\n  color: var(--color-theme-blue) !important;\n  border: 1px solid var(--color-theme-blue) !important;\n}\n\n.changeNameHeader {\n  font-size: 22px;\n  color: var(--color-font-2);\n  font-weight: bold;\n  margin-bottom: 5px;\n  text-transform: uppercase;\n}\n\n.describtion {\n  text-align: left;\n}\n\n.email {\n  font-size: 16px !important;\n  color: var(--color-font-2);\n}\n\n.succsse_message {\n  width: 100%;\n  height: 55px;\n\n  display: flex;\n  align-items: center;\n  justify-content: space-evenly;\n\n  position: absolute;\n  bottom: 0px;\n  right: 0px;\n\n  color: var(--color-theme-white);\n  font-size: 16px;\n  background: var(--color-theme-green);\n}\n\n.error_message {\n  width: 100%;\n  height: 55px;\n\n  display: flex;\n  align-items: center;\n  justify-content: space-evenly;\n\n  position: absolute;\n  bottom: 0px;\n  right: 0px;\n\n  color: var(--color-theme-white);\n  font-size: 16px;\n  background: var(--color-theme-red);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ChangeSignature_container__9jeJb`,
	"signatre_body": `ChangeSignature_signatre_body__eMKjV`,
	"button_container": `ChangeSignature_button_container__2VvLv`,
	"btn_cancel": `ChangeSignature_btn_cancel__kEvJ5`,
	"btn_confirm": `ChangeSignature_btn_confirm__7lRuw`,
	"changeNameHeader": `ChangeSignature_changeNameHeader__FKD1p`,
	"describtion": `ChangeSignature_describtion__umteQ`,
	"email": `ChangeSignature_email__IF0o4`,
	"succsse_message": `ChangeSignature_succsse_message__BP7YM`,
	"error_message": `ChangeSignature_error_message__6f4LE`
};
export default ___CSS_LOADER_EXPORT___;
